"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorsProvider = exports.useActorsContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const management_1 = require("src/declarations/management");
const registry0_1 = require("src/declarations/registry0");
const configStore0_1 = require("src/declarations/configStore0");
const canisters_1 = require("src/configeek_assets/src/ic/canisters");
const App_1 = require("../../App");
const promiseUtils_1 = require("src/configeek_assets/src/system/mics/promiseUtils");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const ActorsContext = React.createContext(undefined);
const useActorsContext = () => {
    const context = React.useContext(ActorsContext);
    if (!context) {
        throw new Error("useActorsContext must be used within a ActorsContext.Provider");
    }
    return context;
};
exports.useActorsContext = useActorsContext;
const ActorsProvider = (props) => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const createActorWithReusedPromise = (0, react_1.useMemo)(() => {
        return (0, promiseUtils_1.reusePromiseWrapper)(authProviderContext.createActor);
    }, [authProviderContext.createActor]);
    const getManagementActor = (0, use_custom_compare_1.useCustomCompareCallback)(async () => {
        return getActor(canisters_1.Canisters.management, management_1.idlFactory, authProviderContext.state.identity, createActorWithReusedPromise);
    }, [authProviderContext.state.identity, App_1.actorsByCanisterId], lodash_1.default.isEqual);
    const getConfigRegistryActor = (0, use_custom_compare_1.useCustomCompareCallback)(async (canisterId) => {
        return getActor(canisterId, registry0_1.idlFactory, authProviderContext.state.identity, createActorWithReusedPromise);
    }, [authProviderContext.state.identity, App_1.actorsByCanisterId], lodash_1.default.isEqual);
    const getConfigStoreActor = (0, use_custom_compare_1.useCustomCompareCallback)(async (canisterId) => {
        return getActor(canisterId, configStore0_1.idlFactory, authProviderContext.state.identity, createActorWithReusedPromise);
    }, [authProviderContext.state.identity, App_1.actorsByCanisterId], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getManagementActor,
        getConfigStoreActor,
        getConfigRegistryActor,
    }), [
        getManagementActor,
        getConfigStoreActor,
        getConfigRegistryActor,
    ], lodash_1.default.isEqual);
    return React.createElement(ActorsContext.Provider, { value: value }, props.children);
};
exports.ActorsProvider = ActorsProvider;
const getActor = async function (canisterId, idlFactory, identity, createActorFn) {
    let actor = App_1.actorsByCanisterId[canisterId];
    if (actor) {
        //reuse actor
        return actor;
    }
    if (!!process.env.IS_TEST_SERVER) {
        console.log(`getActor[${canisterId}]: ask for actor`);
    }
    actor = await createActorFn(canisterId, idlFactory, {
        agentOptions: {
            identity: identity
        }
    });
    App_1.actorsByCanisterId[canisterId] = actor;
    if (!!process.env.IS_TEST_SERVER) {
        console.log(`getActor[${canisterId}]: new actor`, actor);
    }
    return actor;
};
